















































































import {Component, Vue, Watch } from "vue-property-decorator";

import WebConference from "@share/web-conferences/WebConference.vue";
import ObjectLayout from "@service/layouts/ObjectViewLayout.vue";
import AppointmentMembers from "@share/appointment/components/members/AppointmentMembers.vue"
import PlayerTitle from "@share/common/PlayerTitle.vue";
import PlayerCountdown from "@share/appointment/components/player-countdown/PlayerCountdown.vue";

import { AppointmentService } from "./helpers/AppointmentService";
import { AppointmentDataLoader } from "./helpers/AppointmentDataLoader";
import ComingSoon from "@share/session/components/coming-soon/ComingSoon.vue";
import { DateTime } from "luxon";
import { MScheduleSlot } from "@api/models/meetings-schedule/MeetingsScheduleSlot";
import { UserProfilesService } from "@share/web-conferences/data/UserProfilesService";
import { RepositoryFabric } from "@api/repositories/RepositoryFabric";
import { Notice } from "@service/components/toast/type/Notice";
import { NoticeLevel } from "@service/components/toast/type/Enums";
import { RouteNamesEnum } from "@service/router/RouteNamesEnum";
import { MiniPlayerParams } from "@service/store/types/MiniPlayerState";
import { BackgroundViewHelper } from "@service/components/background-view/BackgroundViewHelper/BackgroundViewHelper";
import { BackgroundViewName } from "@service/components/background-view/types/BackgroundViewName";
import { Route } from "vue-router";
import { MeetingsSlotFabric } from "@share/meetings-schedule/helpers/MeetingsSlotFabric";
import { joinedUserIdsGetter } from "@share/web-conferences/store/getters";
import { stateKey as WcStateKey } from "@share/web-conferences/helpers/StateKey";
import Comments from "@share/comments/components/Comments.vue";
import { SchemaId } from "@api/enums/SchemaId";
import {UserProfile} from "@api/models/UserProfile";
import { noticeActions } from "@service/store/notice/actions";

@Component({
    components: { WebConference, ObjectLayout, ComingSoon, AppointmentMembers, PlayerTitle, PlayerCountdown, Comments }
})
export default class AppointmentRoot extends Vue {

    service: AppointmentService | null = null;
    loaded = false;

    /**
     * начался ли слот участника
     */
    memberSlotIsBegin = false;

    /**
     * member is successfuly joined to webconference
     */
    joinedSuccessfully: boolean | null = null;

    webConfUserProfilesService: UserProfilesService | null = null;

    /**
     * список userIds забаненных пользователей
     */
    bannedUserIds: number[] = [];
    slotBeginTimer: NodeJS.Timeout | null = null;
    time = "";
    currentSlot: MScheduleSlot | null = null;

    SchemaId = SchemaId

    created() {
        this.service = new AppointmentService(
            new AppointmentDataLoader(this.$repositories),
            this.$repositories.get(RepositoryFabric.WEB_CONFERENCE),
            new MeetingsSlotFabric(),
            this.$router,
            this.$store,
            this.routeParamId,
            this.userId
        );
    }

    mounted() {

        this.init();

        this.setPageTitle();
    }

    async init() {
        await this.service?.loadData(this.isAdmin, this.routeParamId);

        this.loaded = true;

        if(this.slot) {
            this.setSlotIsBegin(this.slot)
        }

        if(this.isAdminOrSpeaker) {
            this.watchSlotsBegin();
        }
        else {
            this.setTime(this.slot)
        }

        this.checkBroadcast(this.isLive);
    }

    joiningHandler(joined: boolean) {
        this.joinedSuccessfully = joined;
    }

    watchSlotsBegin() {

        const now = DateTime.local();
        const currentSlotIndex = this.getCurrentSlotIndex();

        if(currentSlotIndex >= 0) {

            const currentSlot = this.slots[currentSlotIndex];
            const nextSlot = this.slots[currentSlotIndex + 1];

            this.setCurrentSlot(currentSlot || null);
            this.setTime(currentSlot);

            //если в списке слотов есть будущий
            if(nextSlot) {

                //определяем кол-во мс до начала минус 1 мин

                const delay = (nextSlot.beginAt as DateTime).minus({ minutes: 1 }).toMillis() - now.toMillis();

                console.log(delay, "delay")

                if(delay < 0) {
                    const delay = (nextSlot.beginAt as DateTime).toMillis() - now.toMillis();
                    setTimeout(() => {
                        this.watchSlotsBegin();
                    }, Math.abs(delay))
                    return
                }

                //устанавливаем таймер
                this.slotBeginTimer = setTimeout(async () => {

                    await this.service?.updateSlots();

                    const notice: Notice = {
                        text: this.$t("meetings.nextSlotStart").toString(),
                        level: NoticeLevel.warning
                    }

                    this.$store.dispatch(noticeActions.submitNotice, notice);

                    // запускаем повторно для возможно следующих слотов
                    this.watchSlotsBegin();

                }, delay)
            }
        }
    }

    private async checkBroadcast(isNow: boolean) {
        if(isNow) {
            const broadcastIsBusy = BackgroundViewHelper.checkBroadcastIsBusy(this.broadcastQue, BackgroundViewName.appointment, this.schedule?.id);

            if(broadcastIsBusy) {

                const confirmed = await BackgroundViewHelper.doConfirmModal();
                if(confirmed && confirmed !== "close") {
                    this.$emit('liveConfirmed', true);
                }
                else {
                    if(BackgroundViewHelper.getActiveBroadcastView(this.broadcastQue) === BackgroundViewName.appointment) {
                        this.$store.dispatch("backgroundView/setOffline", BackgroundViewName.appointment);
                    }
                    else {
                        this.$emit('liveConfirmed', false);
                    }

                    this.$router.back();
                }
            }
            else {
                this.$emit('liveConfirmed', true);
            }
        }
    }

    async ban(userId: number) {

        const banned = await this.service?.banUser(userId);

        if(banned) {
            this.bannedUserIds.push(userId);
        }
    }

    update() {
        this.slot && this.setSlotIsBegin(this.slot)

        if(this.memberSlotIsBegin) {
            this.$emit('liveConfirmed', true);
        }
    }

    setSlotIsBegin(slot: MScheduleSlot) {
        const now = DateTime.local();

        this.memberSlotIsBegin = slot.beginAt < now.plus({minutes: 1});
    }

    setCurrentSlot(slot: MScheduleSlot | null) {
        this.currentSlot = slot
    }

    close() {
        this.$emit('liveConfirmed', false);

        this.$router.push({
            name: RouteNamesEnum.meetingsSchedule
        })
    }

    @Watch('profiles')
    watchProfiles() {
        if(!this.activeSlots.length) {
            // update slots when admin don't have actual state of current slot
            this.service?.updateSlots()
        }
    }

    @Watch('route')
    watchRoute(route: Route) {
        if(route.name === RouteNamesEnum.appointment) {
            this.setPageTitle()
        }
        else if(!this.isLive) {
            this.$emit('liveConfirmed', false);
        }
    }

    @Watch('routeParamId')
    watchRouteParamId() {
        if(this.$route.name === RouteNamesEnum.appointment) {
            this.init()
        }
    }

    setPageTitle() {
        this.$store.dispatch("setPageTitle", this.$t("common.appointment"));
    }

    get previewObject() {
        return { beginAt: this.slot?.beginAt }
    }

    get schedule() {
        return this.service?.schedule
    }

    get slot() {
        return this.service?.memberSlot
    }

    get slots() {
        return this.service?.slots || [];
    }

    get speakers() {
        return this.service?.schedule?.userIds?.map(item => new UserProfile({userId: item})) ?? [];
    }

    get activeSlots() {
        return this.slots
            .filter((slot) => {
                return this.membersIds.includes(slot.ownerId?.toString() || "")
            })
            .sort((a: MScheduleSlot, b: MScheduleSlot) => {
                if (a.beginAt && b.beginAt) {
                    if (a.beginAt > b.beginAt) { return 1; }
                    if (a.beginAt < b.beginAt) { return -1 }
                }
                return 0;
            })
    }

    get membersIds() {
        const joinedUserIds = (this.$store.getters[joinedUserIdsGetter](WcStateKey("MeetingsSchedule", this.schedule?.id || "")) || []) as number[];

        return Object.keys(this.profiles)
        .filter((userId) => (
            !this.schedule?.userIds?.includes(+userId)
            && (this.isAdminOrSpeaker && this.userId !== +userId)
            && !this.bannedUserIds.includes(+userId)
            && joinedUserIds.includes(+userId)
        ))
    }

    get profiles() {
        return this.webConfUserProfilesService?.profiles || {};
    }

    setVideoController({ userProfilesService }: { userProfilesService: UserProfilesService }) {

        this.webConfUserProfilesService = userProfilesService;

        if(this.isLive) {
            const params: MiniPlayerParams = {
                object: this.schedule || null,
                returnRouteName: RouteNamesEnum.appointment || "Home"
            }

            this.$emit('updateMiniPlayerParams', params);
        }
    }

    private getCurrentSlotIndex() {
        const now = DateTime.local();
        return this.slots.findIndex((slot) => {
            return (now.plus({seconds: 1}) >= (slot.beginAt as DateTime) && now.plus({seconds: 1}) <= (slot.endAt as DateTime)) || now < (slot.beginAt as DateTime)
        })
    }

    private get speakersNames() {
        return Object.keys(this.profiles)
            .filter((userId: string) => this.schedule?.userIds?.includes(+userId))
            .map((userId: string) => this.profiles[+userId].fullName).join(", ")
    }

    get currentSlotOwnerName() {

        const currentSlot = this.activeSlots[0];

        if(currentSlot) {
            return this.profiles[currentSlot.ownerId || 0]?.fullName || ""
        }
        else {
            return ""
        }
    }

    setTime(slot: MScheduleSlot | undefined) {
        if(slot) {
            this.time = `${(slot.beginAt as DateTime).toFormat("HH:mm") || ""} - ${(slot.endAt as DateTime).toFormat("HH:mm") || ""}`;
        }
    }

    private get isLive() {
        return this.schedule && this.memberSlotIsBegin || Boolean((this.isAdminOrSpeaker && this.schedule))
    }

    private get isAdminOrSpeaker() {
        return this.isAdmin || this.isSpeaker
    }

    private get isAdmin(): boolean {
      return this.$store.getters['isAdmin'];
    }

    private get isSpeaker() {
        return this.schedule?.userIds?.includes(this.userId);
    }

    private get userId(): number {
        return this.$store.state.session.userId;
    }

    get broadcastQue() {
        return this.$store.state.backgroundView.broadcastQue;
    }

    get routeParamId() {
        return this.$route.params.id;
    }

    get route() {
        return this.$route
    }

    destroyed() {
        if(this.slotBeginTimer) {
            clearTimeout(this.slotBeginTimer)
        }
    }
}
